<template>
  <div class="mx-auto bg-dakGrey w-full pt-12">
  <div
    class="max-w-screen-xl mx-auto pb-12 pt-6 px-4 overflow-hidden sm:px-6 lg:px-8 text-lightFont hover:text-darkFont border-one-white"
  >
    <nav class="-mx-5 -my-2 flex flex-wrap justify-center">
      <div class="px-5 py-2">
        <a
          href="https://www.vectric.com" target="_blank"
          class="font-semibold tracking-wide leading-6 text-lightFont hover:text-darkFont uppercase"
        >
          About
        </a>
      </div>
      <div class="px-5 py-2">
        <a
          href="https://www.vectric.com/support" target="_blank"
          class="font-semibold tracking-wide leading-6 text-lightFont hover:text-darkFont uppercase"
        >
          Support
        </a>
      </div>
      <div class="px-5 py-2">
        <a
          href="https://forum.vectric.com" target="_blank"
          class="font-semibold tracking-wide leading-6 text-lightFont hover:text-darkFont uppercase"
        >
          Forum
        </a>
      </div>
      <div class="px-5 py-2">
        <a
          href="https://portal.vectric.com" target="_blank"
          class="font-semibold tracking-wide leading-6 text-lightFont hover:text-darkFont uppercase"
        >
          V&amp;Co
        </a>
      </div>
      <div class="px-5 py-2">
        <a
          href="/privacy"
          class="font-semibold tracking-wide leading-6 text-lightFont hover:text-darkFont uppercase"
        >
          Privacy Policy
        </a>
      </div>
    </nav>
    <div class="mt-8 flex justify-center">
      <a
        href="https://www.facebook.com/vectric" target="_blank"
        class="text-lightFont hover:text-darkFont transform duration-300 ease-in-out hover:scale-125"
      >
        <span class="sr-only">Facebook</span>
        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
          <path
            fill-rule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
      <a
        href="https://www.youtube.com/vectric" target="_blank"
        class="ml-6 text-lightFont hover:text-darkFont transform duration-300 ease-in-out hover:scale-125"
      >
        <span class="sr-only">YouTube</span>
        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 300 300">
          <path
            fill-rule="evenodd"
            d="m 149.9375,79.222656 c 0,0 -63.218849,5.9e-5 -79.085938,4.123047 -8.495787,2.373802 -15.491408,9.3695 -17.865234,17.990237 -4.122953,15.8671 -4.123047,48.72656 -4.123047,48.72656 0,0 9.4e-5,32.9842 4.123047,48.60156 2.373826,8.62062 9.244506,15.49138 17.865234,17.86524 15.99203,4.24788 79.085938,4.24804 79.085938,4.24804 0,0 63.34418,-5e-5 79.21094,-4.12304 8.62079,-2.37381 15.49133,-9.11966 17.74023,-17.86524 4.24793,-15.74232 4.24805,-48.60156 4.24805,-48.60156 0,0 0.12484,-32.98446 -4.24805,-48.85156 -2.2489,-8.620737 -9.11944,-15.491334 -17.74023,-17.740237 -15.86676,-4.372847 -79.21094,-4.373047 -79.21094,-4.373047 z m -20.11523,40.480464 52.59961,30.35938 -52.59961,30.23438 0,-60.59376 z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
      <a
        href="https://www.instagram.com/vectricltd/" target="_blank"
        class="ml-6 text-lightFont hover:text-darkFont transform duration-300 ease-in-out hover:scale-125"
      >
        <span class="sr-only">Instagram</span>
        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
          <path
            fill-rule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
    </div>
    <div class="mt-8">
      <div class="text-center tracking-wide leading-6 text-sm">
        <span
          class=" bg-clip-text
              text-transparent bg-gradient-to-r text-lightFont"
        >
          &copy; 2025 Vectric Ltd. All rights reserved.
        </span>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      to: "",
      showMobileMenu: false
    };
  },
  computed: {},
  watch: {
    $route() {
      this.showMobileMenu = false;
    }
  }
};
</script>
<style scoped>

.border-one-white {
  border-top: 3px solid #ffffff;
}

.bg-dakGrey {
  background: rgb(229, 231, 235);
}

</style>
